<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Proceso Acreditación"
          directory="Asignaciones Pendientes"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
        </div>
      </div>
      <div class="col-md-12">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>
  </div>
</template>

<script>
import * as actions from "../../apiURL";
export default {
  props: {
    evalTestId: String,
  },
  data() {
    return {
      app_type: "",
      icon: "settings",
      tabsHorizontal: [
        {
          icon: "briefcase",
          name: "Equipo Evaluador",
          component: "evaluation-team",
          permission: "",
        },
      ],
    };
  },
  created() {
    this.$store.state.evaluatorReview.evalTestId = this.evalTestId;
    this.data();
  },
  methods: {
    returnPage() {
      window.location.href = "/evaluator/pending/assignments";
    },
    data() {
      this.$store.dispatch("getEvalTest");
    },
  },
};
</script>
